import "./style.css";
import RightSideCars from "./components/RightSideCars.jsx";
import LeftSide from "./components/LeftSide.jsx";
import { fetchQuote } from "../api/api.js";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PremiumLoader from "../components/PremiumLoader";

const ThirdStep = () => {
  const bookingData = useSelector((state) => state.booking);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const handleFetchQuote = async () => {
    if (!bookingData) return;
    const requestData = {
      booster_seat: bookingData.booster || "0",
      domain_id: bookingData.domain_id,
      end: bookingData.dropoff?.address || "",
      end_lat: bookingData.dropoff?.coordinates?.lat || 0,
      end_lng: bookingData.dropoff?.coordinates?.lng || 0,
      infant_seat: bookingData.infant || "0",
      luggage: bookingData.luggage || "0",
      passengers: bookingData.passenger || "1",
      pick_date: bookingData.date || "",
      pick_time: bookingData.time || "",
      regular_seat: bookingData.regular || "0",
      service_type: bookingData.service_type || "",
      start: bookingData.pickup?.address || "",
      start_lat: bookingData.pickup?.coordinates?.lat || 0,
      start_lng: bookingData.pickup?.coordinates?.lng || 0,
    };

    try {
      setLoading(true); 
      const response = await fetchQuote(requestData);
      setData(response.data);
    } catch (error) {
      console.error("Error fetching quote:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleFetchQuote();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#0b0f17] text-slate-100 py-8 px-4 sm:px-6 lg:px-8">
      {loading && (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-slate-950/80 backdrop-blur-md">
          <PremiumLoader />
          <p className="mt-4 text-xs font-bold uppercase tracking-widest text-amber-400">Loading Available Chauffeurs...</p>
        </div>
      )}
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-28 rounded-3xl bg-slate-900/80 border border-white/10 p-6 backdrop-blur-xl shadow-2xl">
            <LeftSide />
          </div>
          <div className="lg:col-span-8 rounded-3xl bg-slate-900/60 border border-white/10 p-6 sm:p-8 backdrop-blur-xl shadow-2xl">
            {!loading && <RightSideCars data={data} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThirdStep;
